// Eisbären Fan-Shop — globale Kleinigkeiten
// Produktkarten: Bildbereich überall klickbar machen (führt zum Produkt).
// Dawns gestreckter Titel-Link deckt durch unser absolutes Overlay nur noch
// den Info-Bereich ab — diese Delegation macht das komplette Bild klickbar.
document.addEventListener('click', (event) => {
  const inner = event.target.closest('.product-card-wrapper .card__inner');
  if (!inner) return;
  // Echte Links/Buttons (Quick-Add, Badges mit Link) nicht überschreiben
  if (event.target.closest('a, button, .quick-add, modal-opener')) return;
  const link = inner.closest('.product-card-wrapper').querySelector('.card__heading a[href]');
  if (link) window.location.href = link.href;
});
